import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

import { registerSingleLine } from './registerSingleLine';

/** Enables `features.singleLine`; see `registerSingleLine`. */
export const SingleLinePlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => registerSingleLine(editor), [editor]);

  return null;
};
